module.exports = __webpack_public_path__ + "AvenirNextCondensed-Regular-0d63c0841dc1da43e569380debf7e58e.ttf";